// SPV Pool v1.0 — small formatting helpers shared by the capital-markets
// pages. Keep these dependency-free so tests can import them cheaply.

export function formatCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(value);
}

/** Renders a 0..1 decimal as a percentage string. */
export function formatPct(value: number | null | undefined, digits = 1): string {
  if (value === null || value === undefined || Number.isNaN(value)) return "—";
  return `${(value * 100).toFixed(digits)}%`;
}

import { FALLBACK_TIMEZONE, formatDateInTz } from "@/utils/datetime";

export function formatDate(value: string | null | undefined, tz: string = FALLBACK_TIMEZONE): string {
  if (!value) return "—";
  return formatDateInTz(value, tz) || "—";
}

/** Convert a PascalCase / camelCase status into a spaced label. */
export function humanizeStatus(value: string): string {
  return value
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2");
}

/** Trigger a client-side CSV download. */
export function downloadCsv(filename: string, rows: string[][]): void {
  const escape = (s: string) => `"${String(s).replace(/"/g, '""')}"`;
  const text = rows.map((r) => r.map(escape).join(",")).join("\n");
  const blob = new Blob([text], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
